module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm.neighborhoodInfo.name))]), _vm._v(" collisions since "), _c('span', [_vm._v("January 1, 2006")])]), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-large"
  }, [_c('MonthlyCollisions', {
    attrs: {
      "getters": {
        average: 'neighborhoodView/monthlyCollisions/average',
        monthlyCollisions: 'neighborhoodView/monthlyCollisions/get',
        total: 'neighborhoodView/monthlyCollisions/total'
      }
    }
  }), _vm._v(" "), _c('DamageCosts', {
    attrs: {
      "getter": 'neighborhoodView/damageCosts/get',
      "title": 'Economic costs',
      "bar-color": this.$store.getters.green.light.a
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-small"
  }, [_c('WhoRank', {
    attrs: {
      "getters": {
        rankings: 'neighborhoodView/whoRank/get'
      }
    }
  }), _vm._v(" "), _c('SeverityRank', {
    attrs: {
      "getters": {
        rankings: 'neighborhoodView/severityRank/get'
      }
    }
  }), _vm._v(" "), _c('Weather', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'cloud',
      "getter": 'neighborhoodView/weather/get',
      "table-color": 'blue',
      "title": 'Weather',
      "bar-color": this.$store.getters.blue.light.a,
      "chart-height": 380,
      "x-min-axes-rotation": 75
    }
  }), _vm._v(" "), _c('RoadConditions', {
    attrs: {
      "card-color": 'orange',
      "getter": 'neighborhoodView/roadConditions/get',
      "table-color": 'orange',
      "title": 'Road conditions',
      "bar-color": this.$store.getters.orange.light.a
    }
  }), _vm._v(" "), _c('LightConditions', {
    attrs: {
      "card-color": 'yellow',
      "card-icon": 'wb_incandescent',
      "getter": 'neighborhoodView/lightConditions/get',
      "table-color": 'yellow',
      "title": 'Light conditions',
      "bar-color": this.$store.getters.yellow.light.a
    }
  }), _vm._v(" "), _c('CollisionTypes', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'call_split',
      "getter": 'neighborhoodView/collisionTypes/get',
      "table-color": 'purple',
      "title": 'Collision types',
      "bar-color": this.$store.getters.purple.light.a
    }
  }), _vm._v(" "), _c('JunctionTypes', {
    attrs: {
      "card-color": 'teal',
      "getter": 'neighborhoodView/junctionTypes/get',
      "table-color": 'teal',
      "title": 'Junction types',
      "bar-color": this.$store.getters.teal.light.b,
      "chart-height": 520,
      "x-min-axes-rotation": 80
    }
  }), _vm._v(" "), _c('AddressTypes', {
    attrs: {
      "card-color": 'teal',
      "getter": 'neighborhoodView/addressTypes/get',
      "table-color": 'teal',
      "title": 'Address types',
      "bar-color": this.$store.getters.teal.light.b
    }
  })], 1), _vm._v(" "), _c('SeattleCityCouncilInformation'), _vm._v(" "), _c('Geo', {
    attrs: {
      "multipolygons": _vm.multipolygons
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-575e7a14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Neighborhood.vue
// module id = 437
// module chunks = 1